import { HttpErrorResponse } from "@angular/common/http";
// import { throwError } from 'rxjs';
import { ErrorHandler, Injectable } from "@angular/core";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  handleError(error: any): void {
   const chunkFailedMessage = /Loading chunk (.)+? failed/;
   if (chunkFailedMessage.test(error.message)) {
     window.location.href = '/';
    }
  }
}

// export const handleHttpError = (error: HttpErrorResponse)=>{
//   if (error.status === 0) {
//     alert(error.message);
//   } else {
//     alert(error.status);
//   }
//   return throwError(() => new Error('Something bad happened; please try again later.'));
// }